module.exports = "/_next/static/resources/box-35ef00dc06a6a8be4eb9e115c57be398.webp";